// Seasonal extras: looks, wallpapers and a Quests collectible that are only offered for a fixed
// window. Each window is New York dates (America/New_York), turned into UTC instants by nyDay so
// every browser agrees whatever its own time zone is (test/seasons.test.mjs checks them against
// the real zone). `until` is the first day that is no longer part of the season.
//
// Outside the window the pickers leave a seasonal item out, but anything a student already
// chose keeps working: THEMES and WALLPAPER_PRESETS still hold it, so the theme, the wallpaper
// and an earned collectible stay as they are. Nobody's settings are reset when a season ends,
// and the picker still shows the item while it is the one in use, so it never looks broken.
//
// Never remove a season or a seasonal item once it has shipped (test/seasons.test.mjs keeps the
// list): people who picked it are still using it.

// The UTC instant of 00:00 New York time on a "YYYY-MM-DD" date. US daylight time runs from the
// second Sunday of March to the first Sunday of November, and midnight is never inside a switch.
export function nyDay(ymd) {
	const [y, m, d] = ymd.split("-").map(Number);
	const sunday = (mo, n) => 1 + ((7 - new Date(Date.UTC(y, mo - 1, 1)).getUTCDay()) % 7) + 7 * (n - 1);
	const summer = (m > 3 && m < 11) || (m === 3 && d > sunday(3, 2)) || (m === 11 && d <= sunday(11, 1));
	return Date.UTC(y, m - 1, d, summer ? 4 : 5);
}

// `label` names the season (the collectible and the runbook use it); `group` is the title of its
// section in the Settings Looks grid; `snow` offers the opt-in light snowfall while it's open.
export const SEASONS = {
	// Mon 10-26 through the end of Sun 11-01 (clocks go back that night).
	"spooky-2026": { label: "Spooky Week 2026", group: "Spooky Week", from: /* @__PURE__ */ nyDay("2026-10-26"), until: /* @__PURE__ */ nyDay("2026-11-02") },
	// The Holiday Update: Mon 11-30 through the end of Fri 1-1.
	"winter-2026": { label: "Winter 2026", group: "Winter", snow: true, from: /* @__PURE__ */ nyDay("2026-11-30"), until: /* @__PURE__ */ nyDay("2027-01-02") },
};

// The Looks grid section title for a season (pure, so a chunk that doesn't use it drops it).
export const seasonGroup = (id) => SEASONS[id].group;

const open = (s, now) => !!s && now >= s.from && now < s.until;
export const seasonOpen = (id, now = Date.now()) => open(SEASONS[id], now);

// Whether a season with light snowfall is open right now (theme.js and the Settings row use it,
// so a later winter only needs `snow: true` in its own entry).
export const snowOpen = (now = Date.now()) => Object.values(SEASONS).some((s) => s.snow && open(s, now));

// Whether a picker should list an item. `inUse` is true when it's the student's current choice.
export const offered = (item, inUse = false, now = Date.now()) => !item || !item.season || inUse || seasonOpen(item.season, now);
